import { useEffect, useState } from 'react';
import { Navigate, Outlet, useLocation } from "react-router-dom";
import {
    ApplicationPaths,
    QueryParameterNames
} from './ApiAuthorizationConstants';
import authService from './AuthorizeService';

const AuthorizeRoute = (props) => {
    const [ready, setReady] = useState(false);
    const [authenticated, setAuthenticated] = useState(false);
    const location = useLocation();

    useEffect(() => {
        const subscription = authService.subscribe(() => authenticationChanged());
        populateAuthenticationState();

        return () => {
            authService.unsubscribe(subscription);
        };
    }, []);

    const populateAuthenticationState = async () => {
        const isAuthenticated = await authService.isAuthenticated();
        setReady(true);
        setAuthenticated(isAuthenticated);
    };

    const authenticationChanged = async () => {
        setReady(false);
        setAuthenticated(false);
        await populateAuthenticationState();
    };

    if (!ready) {
        return <div>Loading...</div>;
    }

    const returnUrl = window.location.origin + location.pathname + location.search + location.hash;
    const redirectUrl = `${ApplicationPaths.Login}?${QueryParameterNames.ReturnUrl}=${encodeURIComponent(returnUrl)}`;

    if (!authenticated) {
        if (ApplicationPaths.Login.startsWith("http")) {
            window.location.replace(redirectUrl);
            return null;
        }

        return <Navigate to={redirectUrl} replace />;
    }

    return <Outlet />;

};

export default AuthorizeRoute;

